import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddressBookComponent } from './components/address-book/address-book.component';
import { CreateAddressComponent } from './components/create-address/create-address.component';
import { EditAddressComponent } from './components/edit-address/edit-address.component';
import { AddressesComponent } from './components/addresses/addresses.component';

export const addressBookRoutes: Routes = [
  {
    path: '',
    component: AddressBookComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: AddressesComponent,
      },
      {
        path: 'create-address',
        component: CreateAddressComponent,
        data: { title: 'TITLE.PAGE.ACCOUNT.ADDRESS_BOOK.CREATE' },
      },
      {
        path: 'edit-address',
        component: EditAddressComponent,
        data: { title: 'TITLE.PAGE.ACCOUNT.ADDRESS_BOOK.EDIT' },
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(addressBookRoutes)],
  exports: [RouterModule],
})
export class AddressBookRoutingModule {}
